.vc-plugin-modal-info {
    align-items: center;
}

.vc-plugin-modal-description {
    flex-grow: 1;
}
